<let/email="">
<let/status="">

<div class="wrap py-6">
  <div class="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
    <module role="spaces" title="Explore" as="nav" ariaLabel="Explore">
      <ul class="p-3 sm:p-4 grid gap-2 label">
        <li><a href="/projects">Projects</a></li>
        <li><a href="/shop">Shop</a></li>
        <li><a href="/testimony">Testimony</a></li>
        <li><a href="/squad">Squad</a></li>
      </ul>
    </module>
    <module role="systems" title="Read" as="nav" ariaLabel="Read">
      <ul class="p-3 sm:p-4 grid gap-2 label">
        <li><a href="/thoughts">Thoughts</a></li>
        <li><a href="/news">News</a></li>
        <li><a href="/sources">Sources</a></li>
      </ul>
    </module>
    <module role="routines" title="Support" as="nav" ariaLabel="Support" class="col-span-2 lg:col-span-1">
      <ul class="p-3 sm:p-4 grid grid-cols-2 lg:grid-cols-1 gap-2 label">
        <li><a href="/faq">FAQ</a></li>
        <li><a href="/about">About</a></li>
        <li><a href="mailto:jay.zehngebot@gmail.com?subject=Mark%20Condor">Contact</a></li>
        <li><a href="/hire">Hire</a></li>
      </ul>
    </module>
    <!-- Module markup written out: this one holds the stateful form. -->
    <section class="mod col-span-2 lg:col-span-1">
      <div class="mod-bar bar--action">
        <span class="mod-title label"><span class="disc" aria-hidden="true"></span>Dispatch list</span>
      </div>
      <div class="mod-body">
      <div class="p-4">
        <p class="text-sm text-c-500 mb-3">Occasional dispatches.</p>
        <form
          class="flex gap-2"
          onSubmit(e) {
            e.preventDefault();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
              status = "Invalid address.";
              return;
            }
            status = "Sending...";
            fetch("/api/addToMailingList", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ email, website: e.target.website.value }),
            })
              .then((response) => {
                status = response.ok ? "Confirmed." : response.status === 429 ? "Too many attempts. Try later." : "Failed.";
                if (response.ok) email = "";
              })
              .catch(() => {
                status = "Error.";
              });
          }
        >
          <label for="dispatch-email" class="sr-only">Email address</label>
          <input
            id="dispatch-email"
            name="email"
            class="flex-1 min-w-0 px-3 py-2 text-base !bg-transparent !border-[#3a3a42] !text-[#f2f2f2]"
            type="email"
            autocomplete="email"
            placeholder="Email"
            required
            value=email
            onInput(e) { email = e.target.value }
          />
          <!-- Honeypot: hidden from people, filled in by bots -->
          <input name="website" type="text" tabindex="-1" autocomplete="off" aria-hidden="true" class="hidden"/>
          <button type="submit" class="cta cta--red !py-2">Join</button>
        </form>
        <p class="text-sm text-c-400 mt-2 min-h-6" role="status" aria-live="polite">${status}</p>
      </div>
      </div>
    </section>
  </div>
</div>
